import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    WidgetStagesetUpdate as WidgetStagesetUpdateMutation,
    WidgetStagesetUpdateVariables,
    WidgetStagesetUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_WIDGET_STAGESET from '../mutations/update-widget-stageset.graphql';

export const useUpdateWidgetStageset = (): {
    updateWidgetStageset: (arg1: WidgetStagesetUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateWidgetStageset, {loading, error}] = useMutation<
        WidgetStagesetUpdateMutation,
        WidgetStagesetUpdateVariables
    >(UPDATE_WIDGET_STAGESET);

    return {
        updateWidgetStageset: (input: WidgetStagesetUpdateInput) =>
            updateWidgetStageset({
                variables: {input},
                refetchQueries: ['GetStagesetWidgets'],
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
